import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <section id="faq" className="bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-3xl">
        <SectionHeading
          eyebrow="常见问题"
          title="关于这部剧与这一页，你可能想问"
          desc="把大家问得最多的几个问题集中放在这里，看完还有疑问，可以到剧迷社区继续讨论。"
          align="center"
        />

        <div className="mt-10 space-y-3 md:mt-14">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.q}
                className={`reveal overflow-hidden rounded-lg border bg-background-100 transition-colors ${
                  isOpen ? 'border-primary-300' : 'border-background-200'
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => toggle(index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center gap-4 px-5 py-4 text-left transition-colors hover:bg-background-200/50 md:px-6"
                  >
                    <span className="flex-1 font-heading text-sm font-semibold text-foreground-950 md:text-base">
                      {faq.q}
                    </span>
                    <i
                      className={`ri-add-line shrink-0 text-xl text-primary-600 transition-transform duration-300 ${
                        isOpen ? 'rotate-45' : ''
                      }`}
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="border-t border-background-200 px-5 pb-5 pt-4 text-sm leading-7 text-foreground-600 md:px-6 md:leading-8">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}